import { formatMoney } from '~shared/lib/format-money';

import type { TooltipProps } from 'recharts';

import { isMoneyType } from '../lib';
import type { SummaryDataField } from '../types';

export const renderTooltip = ({
  payload,
  label,
}: TooltipProps<number, string>) => {
  if (payload && payload.length > 0) {
    const { name, value } = payload[0];
    const formattedDate = new Date(label).toLocaleDateString('en', {
      month: 'long',
      day: 'numeric',
    });

    const formattedValue =
      name && value && isMoneyType(name as SummaryDataField)
        ? formatMoney(value)
        : value;
    return (
      <div className="rounded-[12px] bg-white px-4 py-3 shadow-sm">
        <p className="mb-1 mt-0 text-[13px] text-black/50">{formattedDate}</p>
        <p className="my-0 text-[17px] text-black/80">{formattedValue}</p>
      </div>
    );
  }
  return null;
};
